module.exports = __webpack_public_path__ + "img/newProduct.8d12a09d.svg";